<template>
    <div class="container" style="padding-top: 50px;">
        <div class="row">
            <div class="col-md-4 col-md-offset-4">
                <form name="form">
                    <div class="form-group" :class="{ 'is-invalid': submitted && $v.account.email.$error }">
                        <label for="email">Email address:</label>
                        <input v-model="account.email" type="text" class="form-control" placeholder="Enter email" id="email">
                        <div v-if="submitted && !$v.account.email.required" class="invalid">Vui lòng nhập email</div>
                    </div>
                    <div class="form-group" :class="{ 'is-invalid': submitted && $v.account.password.$error }">
                        <label for="pwd">Password:</label>
                        <input v-model="account.password" type="password" class="form-control" placeholder="Enter password" id="pwd">
                        <div v-if="submitted && !$v.account.password.required" class="invalid">Vui lòng nhập mật khẩu</div>
                    </div>
                    <button v-on:click="login()" type="button" class="btn btn-primary">Submit</button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import loginService from './../_api/loginService';
    import { required } from "vuelidate/lib/validators";

    export default {
        name: 'Login',
        data() {
            return {
                submitted: false,
                account: { email: 'gv8@gmail.com', password: '123456' },
            }
        },
        methods: {
            ...mapActions('common', ['setLoading']),

            login(){
                this.submitted = true;
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                let self = this;
                self.setLoading(true);
                loginService.login(this.account)
                  .then((response) => {
                      if (response.data.status == 'success') {
                          this.$cookies.set('login-info', response.data.data);
                      }
                      else{
                            alert("Đăng nhập không thành công");
                      }
                  }).catch(e => { this.errors.push(e) })
                  .finally(() => { self.setLoading(false)});
            },
        },
        computed: {

        },
        watch: {
            
        },
        created() {
            
        },
        mounted(){
          
        },
        validations: {
          account: {
              email: { required },
              password: { required }
          }
        },  
    }
</script>
